import { Link } from "react-router-dom";
import { Activity } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-slate-800/60 bg-[#0B0F16] mt-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-10">
      <div className="flex flex-col md:flex-row justify-between gap-8">
        <div className="max-w-sm">
          <div className="flex items-center gap-2 mb-3">
            <Activity className="text-emerald-400" size={18} />
            <span className="font-display font-extrabold text-lg">Quantum<span className="text-gradient">Signal</span> AI</span>
          </div>
          <p className="text-sm text-slate-500">
            AI-powered trading signals for Forex, Gold and Crypto. Analysis is for educational
            purposes and is not financial advice.
          </p>
        </div>
        <div className="flex gap-16">
          <div>
            <p className="text-xs font-semibold text-slate-300 uppercase tracking-wide mb-3">Product</p>
            <ul className="space-y-2 text-sm text-slate-500">
              <li><Link to="/signals" className="hover:text-emerald-400">Signals</Link></li>
              <li><Link to="/performance" className="hover:text-emerald-400">Performance</Link></li>
              <li><Link to="/pricing" className="hover:text-emerald-400">Pricing</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold text-slate-300 uppercase tracking-wide mb-3">Markets</p>
            <ul className="space-y-2 text-sm text-slate-500">
              <li>Gold (XAU/USD)</li>
              <li>Forex Majors</li>
              <li>Crypto</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-800/60 mt-8 pt-6 text-xs text-slate-600 flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} QuantumSignal AI. All rights reserved.</span>
        <span>Trading involves risk. Past performance is not indicative of future results.</span>
      </div>
    </div>
  </footer>
);
